import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";
import { inputVariants } from "../../lib/variants.js";

const Select = forwardRef(
  (
    {
      className,
      variant = "default",
      size = "md",
      error,
      success,
      disabled = false,
      children,
      ...props
    },
    ref
  ) => {
    const baseClasses = "w-full bg-white text-warm-900 border rounded-xl px-4 transition-colors outline-none disabled:bg-warm-100 disabled:cursor-not-allowed appearance-none";
    
    let finalVariant = variant;
    if (error) finalVariant = "error";
    if (success) finalVariant = "success";
    
    const variantClasses = inputVariants.variant[finalVariant] || inputVariants.variant.default;
    const sizeClasses = inputVariants.size[size] || inputVariants.size.md;
    
    return (
      <select
        ref={ref}
        className={cn(
          baseClasses,
          variantClasses,
          sizeClasses,
          "pr-10 bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20fill%3D%22%236b7280%22%20d%3D%22M8%2011.5l4-4H4z%22%2F%3E%3C%2Fsvg%3E')] bg-no-repeat bg-position-[center_right_1rem]",
          className
        )}
        disabled={disabled}
        {...props}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = "Select";

export default Select;